import React from 'react';

interface LoadingSpinnerProps {
  message?: string;
  size?: 'small' | 'medium' | 'large';
  variant?: 'spinner' | 'dots' | 'pulse' | 'bars';
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  message = 'Cargando...', 
  size = 'medium',
  variant = 'spinner'
}) => {
  const sizeClasses = {
    small: 'h-6 w-6',
    medium: 'h-12 w-12',
    large: 'h-20 w-20'
  };

  const renderLoader = () => {
    switch (variant) {
      case 'dots':
        return (
          <div className="flex space-x-2">
            {[0, 1, 2].map((i) => (
              <div
                key={i}
                className="w-3 h-3 bg-blue-600 rounded-full animate-bounce"
                style={{ animationDelay: `${i * 0.15}s` }}
              />
            ))}
          </div>
        );
      
      case 'pulse':
        return (
          <div className={`relative ${sizeClasses[size]}`}>
            <div className="absolute inset-0 bg-blue-600 rounded-full animate-ping opacity-75" />
            <div className="relative bg-blue-600 rounded-full h-full w-full" />
          </div>
        );
      
      case 'bars':
        return (
          <div className="flex space-x-1.5 items-end h-12">
            {[0, 1, 2, 3].map((i) => (
              <div
                key={i}
                className="w-2 bg-blue-600 rounded-full animate-pulse"
                style={{ 
                  height: `${20 + i * 8}px`,
                  animationDelay: `${i * 0.1}s`,
                  animationDuration: '0.8s'
                }}
              />
            ))}
          </div>
        );
      
      default:
        return (
          <div className="relative">
            <div className={`${sizeClasses[size]} border-4 border-gray-200 rounded-full`} />
            <div className={`${sizeClasses[size]} border-4 border-blue-600 rounded-full border-t-transparent animate-spin absolute top-0`} />
          </div>
        );
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center ">
      <div className="text-center p-8 rounded-2xl  ">
        <div className="flex justify-center mb-6">
          {renderLoader()}
        </div>
        <p className="text-gray-700 font-medium text-lg">{message}</p>
      </div>
    </div>
  );
};

export default LoadingSpinner;

